
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProductsHero from './components/ProductsHero';
import ProductsCategories from './components/ProductsCategories';
import ProductsGrid from './components/ProductsGrid';
import ProductsCTA from './components/ProductsCTA';

// Composant formulaire de devis
const QuoteForm = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    product: '',
    quantity: '',
    message: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name || !formData.email || !formData.product) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d47ka5534biqimnfoik0', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        alert('Votre demande de devis a été envoyée avec succès !');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          product: '',
          quantity: '',
          message: ''
        });
        onClose();
      } else {
        alert('Erreur lors de l\'envoi. Veuillez réessayer.');
      }
    } catch (error) {
      alert('Erreur lors de l\'envoi. Veuillez réessayer.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Demande de Devis</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          <form onSubmit={handleSubmit} data-readdy-form id="quote-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nom complet *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Entreprise
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Produit d'intérêt *
                </label>
                <select
                  name="product"
                  value={formData.product}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                >
                  <option value="">Sélectionnez un produit</option>
                  <option value="Caméras IP">Caméras IP</option>
                  <option value="Systèmes d'alarme">Systèmes d'alarme</option>
                  <option value="Contrôle d'accès">Contrôle d'accès</option>
                  <option value="Détecteurs incendie">Détecteurs incendie</option>
                  <option value="Vidéosurveillance">Vidéosurveillance</option>
                  <option value="Interphones">Interphones</option>
                  <option value="Barrières automatiques">Barrières automatiques</option>
                  <option value="Systèmes anti-intrusion">Systèmes anti-intrusion</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Quantité estimée
                </label>
                <input
                  type="text"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  placeholder="Ex: 10 unités"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Message / Spécifications
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                maxLength={500}
                placeholder="Décrivez vos besoins spécifiques..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
              />
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 caractères</p>
            </div>

            <div className="flex gap-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                Annuler
              </button>
              <button
                type="submit"
                className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                Envoyer la demande
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default function ProductsPage() {
  const [isQuoteFormOpen, setIsQuoteFormOpen] = useState(false);

  const openQuoteForm = () => setIsQuoteFormOpen(true);
  const closeQuoteForm = () => setIsQuoteFormOpen(false);

  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Produits Sécurité - Cobra Sécurité | Caméras Alarmes Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez notre gamme complète de produits de sécurité : caméras IP, systèmes d\'alarme, contrôle d\'accès, détection incendie. Qualité professionnelle en Tunisie.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Produits de Sécurité",
      "description": "Catalogue complet de produits de sécurité professionnels",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "Produits de Sécurité Cobra",
        "itemListElement": [
          {
            "@type": "Product",
            "name": "Caméras IP",
            "description": "Caméras de surveillance IP haute définition",
            "category": "Vidéosurveillance"
          },
          {
            "@type": "Product",
            "name": "Systèmes d'Alarme",
            "description": "Systèmes d'alarme anti-intrusion avancés",
            "category": "Sécurité"
          },
          {
            "@type": "Product",
            "name": "Contrôle d'Accès",
            "description": "Solutions de contrôle d'accès biométrique",
            "category": "Contrôle"
          },
          {
            "@type": "Product",
            "name": "Détecteurs Incendie",
            "description": "Systèmes de détection incendie certifiés",
            "category": "Sécurité Incendie"
          }
        ]
      },
      "provider": {
        "@type": "Organization",
        "name": "Cobra Sécurité"
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Produits de Sécurité Professionnels</h1>
        <ProductsHero />
        <ProductsCategories />
        <ProductsGrid onQuoteClick={openQuoteForm} />
        <ProductsCTA />
      </main>
      <Footer />
      
      <QuoteForm isOpen={isQuoteFormOpen} onClose={closeQuoteForm} />
    </div>
  );
}
